import { API } from "@project/shared"

const BASE_URL = "/decide-services"
export const getAllHandicapServices = () => API.get(BASE_URL)
